<template>
    <header id="fd-header">
        <span class="fd-header-logo" @click="toHome">
            <img src="../../images/common/header_logo .png" alt="" />
        </span>
        <!-- <div class="fd-header-but">
            <el-dropdown @command="changeLanguage">
                <el-button size="mini">
                    {{$t('language.name')}}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu size="mini" slot="dropdown">
                    <el-dropdown-item command="zh">简体中文</el-dropdown-item>
                    <el-dropdown-item command="en">English</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div> -->
    </header>
</template>
<style lang='less'>
#fd-header {
    width: 1200px;
    height: 96px;
    font-weight: bold;
    margin: 0 auto;
    font-size: 0;
    flex-shrink: 0;
    padding-top: 28px;
    .fd-header-logo {
        width: 791px;
        height: 40px;
    }
    
    .fd-header-but {
        float: right;
        font-size: 16px;
        font-weight: 400;
    }
    // .fd-header-but {
        // .el-button:hover {
        //     background-color: #fff;
        //     border-color: #0047DC;
        //     color: #0047DC;
        // }
    // }
    // .fd-header-but{
    //     .el-button:active {
    //         background-color: #fff;
    //         border-color: #0047DC;
    //         color: #0047DC;
    //     } 
    // }
    // .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover  {
    //     background-color: #F1F4F8;
    //     color: #0047DC;
    // }

}
@media (max-width: 1200px) {
    #fd-header {
        padding: 0 15px;
    }
}
</style>
<script>
export default {
    name: "heardes",
    data() {
        return {};
    },
    methods: {
        toHome() {
            this.$router.push({
                path: "/",
            });
        },
        changeLanguage(type) {
            this.$i18n.locale = type; // 设置中英文模式
            localStorage.setItem("languageStorage", this.$i18n.locale); // 将用户设置存储到localStorage以便用户下次打开时使用此设置
            this.$emit("switchLanguage", this.$i18n.locale);
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/common/headers.vue